module.exports = __webpack_public_path__ + "static/media/fatcat_intro.4a4b63e3.png";